import { render, staticRenderFns } from "./AdminAddExpense.vue?vue&type=template&id=17e7a20b&"
import script from "./AdminAddExpense.vue?vue&type=script&lang=js&"
export * from "./AdminAddExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports